
import ListOrder from '../sub-pages/list-order'
import FormAudit from '../sub-pages/form-audit'

export default [
    {
        show(row, extra) {
            return true
        },
        tag: 'el-button',
        type: 'text',
        icon: 'el-icon-document-copy',
        text: '详细订单',
        click(row, extra) {
            this.dialogOpen(ListOrder, '详细订单');
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus == "0" || row.auditstatus == null
            )
        },
        tag: 'el-button',
        type: 'text',
        icon: 'el-icon-finished',
        text: '核实收款',
        click(row, extra) {
            this.dialogOpen(FormAudit, '核实收款');
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus === "1"
                && row.orderstype === 'gkzb-gmbs'
                && row.orderssum !== 0
            )
        },
        tag: 'el-button',
        type: 'text',
        icon: 'el-icon-back',
        text: '退款',
        click(row, extra) {
            var firstRes = null;

            var that = this;

            function query(obj) {
                var query = {
                    orderscode: row.orderscode
                };

                obj.data = obj.data || {};
                mixin(obj.data, query);

                that.$post(`${that.getGetters('mngUrl')}/manage/finance/auditorder/tuihui.json`, query, (data, res) => {
                    if(data && data.code === 'confirm') {
                        firstRes = data;
                        obj.confirm && obj.confirm();
                    } else {
                        obj.success && obj.success(data, res);
                    }
                });
                
            }

            new Chain().link((that, next) => {
                window.ShowConfirm('订单退回，只能修改订单状态，标书款请单独退回！', 'warning', () => {
                    next();
                })
            }).link((that, next) => {
                query({
                    success: (data, res) => {
                        ShowMsg(res.msg, 'success');
                        this.$emit('reload');
                    }, 
                    confirm: () => {
                        next();
                    }
                })
            }).link((that, next) => {
                this.$prompt(`${firstRes.msg}或输入退款原因后继续，确定要继续退款吗`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '必填'
                }).then(({ value }) => {

                    query({
                        success: (data, res) => {
                            ShowMsg(res.msg, 'success');
                            this.$emit('reload');
                        }, 
                        data: {
                            confirmflag: '1',
                            reason: value,
                        }
                    });

                });
            }).run(this);
            
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus === "1"
                && row.orderstype === 'gkzb-gmbs'
                && row.orderssum !== 0
                && row.dldwcode === 'E0000001881'
            )
        },
        tag: 'el-button',
        type: 'text',
        icon: 'el-icon-back',
        text: '退票/冲红',
        click(row, extra) {
            this.$emit('paper',row.orderscode)

            this.$post(`${this.getGetters('mngUrl')}/manage/finance/auditbsk/tuipiao.json`, {
                orderscode: row.orderscode
            }, data => {
                ShowMsg('退票/冲红成功','success');
                this.$emit('reload');
            });
        }
    },
    {
        show(row, extra) {
            return (
                row.auditstatus === "1" 
                && !(row.orderssum === '0' || row.orderssum === 0)
                && (row.fpbj === "0" || !row.fpbj)
            )
        },
        tag: 'el-button',
        type: 'text',
        icon: 'el-icon-tickets',
        text: '开票',
        click(row, extra) {
            this.goto({
                path: './invoice/form',
                query: {
                    orderid: row.orderscode,
                    bdcode: this.getQuery('bdcode'),
                }
            });
        }
    },
]
